export default __webpack_public_path__ + "static/media/04_DAIF_Infra_03_10_end.d8ac58f0.jpg";